import React from 'react';

import PropTypes from 'prop-types';
import { faUser } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Checkbox } from '@/components/ui/checkbox';
import { CommandItem } from '@/components/ui/command';

const NoOwnerItem = ({ isSelected, onSelect }) => (
  <CommandItem onSelect={onSelect} value="No owner">
    <Checkbox checked={isSelected} />

    <div className="flex gap-2 items-center">
      <div className="flex w-5 justify-center">
        <FontAwesomeIcon className="text-muted-foreground" icon={faUser} />
      </div>
      No owner
    </div>
  </CommandItem>
);

NoOwnerItem.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default NoOwnerItem;
